import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { CurationStampParser } from 'react-flybase-utils'

import { Collapse } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

import { stringHashCode } from '../../utils'

// An example class for showing/hiding text.

function Chevron(props) {
  if (props.open) return <FontAwesome name="chevron-down" />
  else return <FontAwesome name="chevron-right" />
}

// Mobx observer annotation
@observer
class SubTextCollapse extends Component {
  constructor(props) {
    super(props)
    // Initial state.
    this.state = {
      open: false,
    }
    // Bind 'this' inside of the handleOnClick function to this class.
    this.handleOnClick = this.handleOnClick.bind(this)
  }

  handleOnClick() {
    this.setState({ open: !this.state.open })
  }

  render() {
    let { label, text } = this.props
    if (!text || text.length === 0) {
      return <div />
    }

    let textarr = text.split(/\n/).map((t) => (
      <React.Fragment key={stringHashCode(t)}>
        <CurationStampParser text={t} />
      </React.Fragment>
    ))

    return (
      <div>
        <div style={{ float: 'left', paddingRight: 20 }}>
          <button
            className={'btn btn-link'}
            onClick={this.handleOnClick}
            style={{
              textDecoration: 'none',
              padding: 0,
              color: 'inherit',
              cursor: 'pointer',
            }}>
            <b>{label}</b>
            &nbsp;
            <Chevron open={this.state.open} />
          </button>
        </div>
        <Collapse in={this.state.open}>
          <p className="small text-justify">{textarr}</p>
        </Collapse>
      </div>
    )
  }
}

SubTextCollapse.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.string,
}

export default SubTextCollapse
